import type { FaireProductEntity } from "../../entity_types/product";

export const p_q9ap27uc7w: FaireProductEntity = {
  token: "p_q9ap27uc7w",
  type: "product",
  name: "SUMMER Message Embroidered Fringe Canvas Tote Beach Bag",
  brandToken: "b_c3xmn96nkh",
  brandName: "Unknown Brand",
  imageUrl:
    "https://cdn.faire.com/fastly/efb92a840b886cde128a27cb4ac14bcde3172b46d46c1f37e5f34f30a728f5a3.jpeg",
  galleryImageUrls: [
    "https://cdn.faire.com/fastly/7e58d949f3080ef3a72ad175053cf06bf26758f6545dfe04c22fd245e8bc31dc.jpeg",
    "https://cdn.faire.com/fastly/b05a0728ef151a3b09715a078699af91b964f6b0d48b69ff9723fcb238d3a9fc.jpeg",
    "https://cdn.faire.com/fastly/039747457af6da5571749b87be53e6daf70ad650846ef73a4e92b902247fcbc5.jpeg",
    "https://cdn.faire.com/fastly/0f31e23db16e74b29aeb45cc46f202bfb7c6ce8898ba2f37e052cfabe4e57c34.jpeg",
    "https://cdn.faire.com/fastly/5c67f8d07c0606a6da8cf85d70621dc4aff8a106daccc2b4d61b8600bf40c8f4.jpeg",
    "https://cdn.faire.com/fastly/c373e6d44f463639314b3acfdeb535374f1b0fabc59783360fc13aac57abbc29.jpeg",
    "https://cdn.faire.com/fastly/3126998ce87f0f557dfad7af3c451d2fce144a8c085a1b7f16649d8881975a81.jpeg",
    "https://cdn.faire.com/fastly/b250087feb384f8bd5111ff3c6fa73feb9c2bbd9da68dc09faf18a7dfb5dd3df.jpeg",
    "https://cdn.faire.com/fastly/3e6b7abbcce8d88bdcd4af8749fde0755ccbab06359cee074962dfc529c1b987.jpeg",
    "https://cdn.faire.com/fastly/3a137193f791ab567401b33b3d61eae30a1b2e1112521551cdf4678d1329c7e0.jpeg",
    "https://cdn.faire.com/fastly/cd8de0f5eb1b5915696be23d38a15f6ae3b8d79e5f6df432633dbc1279a6c602.jpeg",
    "https://cdn.faire.com/fastly/c556ce989e708cc6e26b49e209723540f7075e4033f3d90d0934f4d2d4d072af.jpeg",
    "https://cdn.faire.com/fastly/54d897bd4e541e196bd7906d31765b9db44fdfe0819ef0933fba422ac07d1caa.jpeg",
    "https://cdn.faire.com/fastly/45d5e64b6bd1577399c993ad54c975d61cb1b428d8c50e2227188217e81ef2ea.jpeg",
    "https://cdn.faire.com/fastly/6fb93dc64646b7d2f4c5e6f7f88694180b5864d91235f9ed3dac6767d12df196.jpeg",
    "https://cdn.faire.com/fastly/c60dadfa6ed7f7192096eb91008ebbb686d88074ffd7636c9ff836a334e037e2.jpeg",
    "https://cdn.faire.com/fastly/d66f081c4197108117b65e92aae048a807da7e3c1e50f303f47a0101f0f25d1f.jpeg",
    "https://cdn.faire.com/fastly/d49f1f6c4bbeaa9c33c20c234a4c8c9d6c9447f2dacccda47bbfdcbf25690075.jpeg",
    "https://cdn.faire.com/fastly/a5a8baf61d022eef1d604db7c20cbc0f7140cae2a0b619326f554e5322ba98a4.jpeg",
    "https://cdn.faire.com/fastly/6a9d6fb78814606bfa24b298d15f3b328f7d5243521785ec56bd2ef1c6ab6e77.jpeg",
    "https://cdn.faire.com/fastly/fd1cad6921cd417f0704a998bb0c12b94819502fa285afc526661bab405670ef.jpeg",
  ],
  priceDollars: 17.92,
  description:
    '• Size : 17.5" X 14" X 15"\n• Material : 100% Polyester\n• Zipper Closure\n• One Inside Pocket\n• Celebrate the season with this oversized "Summer" tote, showcasing bold text, contrast handles, and playful frayed edges. Ideal for beach trips, getaways, or casual everyday style with a fun twist.',
  tags: [],
  msrpDollars: 35.83,
  inStock: true,
  meta: {
    source: "api",
    importedAt: "2026-03-26T22:26:18.725Z",
    importedBy: "entity-db-cli",
  },
  categoryTokens: [],
};
